<script setup lang="ts">
import { Head } from '@inertiajs/vue3';
import { useToastStore } from '../stores/toast.ts';
import CopyrightFooter from '../components/snippets/CopyrightFooter.vue';

defineProps<{ fluid?: boolean; title: string }>();

const toast = useToastStore();
</script>

<template>
  <Head :title="title" />
  <VApp>
    <VLayout>
      <VAppBar color="primary">
        <VAppBarTitle>
          <VImg
            alt="logo"
            height="36"
            src="/images/logo/fore_fiber_rectangle_white.svg"
            width="auto"
          />
        </VAppBarTitle>
      </VAppBar>
      <VMain>
        <VContainer>
          <header class="pt-8 pb-4">
            <h1>{{ title }}</h1>
          </header>
        </VContainer>
        <VContainer :fluid="fluid">
          <slot />
        </VContainer>
      </VMain>
        <CopyrightFooter/>
    </VLayout>

    <VSnackbar
      v-model="toast.show"
      :color="toast.color"
      :text="toast.message"
      :timeout="4000"
      location="top"
    />
  </VApp>
</template>
